/*
  BrandName — השם VaddyGo מוצג תמיד מודגש (כלל מחייב מ-ARCHITECTURE.md).
  משתמשים ברכיב הזה בכל מקום שהמותג מופיע, כדי שהכלל לא יישכח.
  (ה-prop withHeart נותר לתאימות לאחור אך אינו מציג עוד לב — בלי סגול.)
*/
function BrandName() {
  return <strong className="brand-name">VaddyGo</strong>;
}

export default BrandName;
